<template>
    <div class="upload-content flex">
        <el-upload
            :ref="uuid"
            :key="key + uuid"
            v-loading="loading"
            class="avatar-uploader"
            :accept="accept"
            action
            :list-type="listType"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            :http-request="upload"
            :file-list="fileList"
            :limit="limit"
            :show-file-list="!!limit"
            :on-change="uploadChange"
            :on-success="uploadSuccess"
            :on-exceed="uploadExceed"
            :thumbnail-mode="thumbnailMode"
        >
            <div
                slot="default"
                class="upload-body wh100p ofh"
            >
                <img
                    v-if="fileData && !limit"
                    :src="fileData"
                    class="avatar"
                >
                <div class="upload-icon-body wh100p flex ac fc">
                    <i class="avatar-uploader-icon el-icon-plus" />
                </div>
            </div>

            <template
                v-if="filterFile(file)"
                slot="file"
                slot-scope="{file}"
            >
                <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                >
                <div class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePreview(file)"
                    >
                        <i class="el-icon-zoom-in" />
                    </span>
                    <span
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                    >
                        <i class="el-icon-delete" />
                    </span>
                </div>
            </template>

            <template slot="tip">
                <div class="tip-body mt10">
                    <span>
                        {{
                            $t('文件格式为', { format: accept, size })
                        }}
                    </span>
                    <span v-if="fileType === 'image'">,{{ $t('分辨率为', { width: resolving[0], height: resolving[1] }) }}</span>
                </div>
            </template>
        </el-upload>
        <v-base-cropper
            :options="cropperOptions"
            :show="showCropper"
            :file="fileUrl"
            @callback="completeCropper"
            @closeCropper="closeCropper"
        />
        <div
            v-if="showImage"
            :ref="uuid"
            class="preview-dialog"
        >
            <i
                class="el-icon-close btn-close"
                @click="handleClosePreview"
            />
            <div class="flex fc ac wh100p">
                <img
                    class="preview-image"
                    :src="dialogImageUrl"
                    alt
                >
            </div>
        </div>
    </div>
</template>
<script>
import BaseCropper from './BaseCropper.vue'

export default {
    name: 'UploadFile',
    components: {
        'v-base-cropper': BaseCropper
    },
    props: {
        listType: {
            default: 'picture-card'
        },
        thumbnailMode: {
            type: Boolean,
            default: false
        },
        fileData: {
            default: ''
        },
        accept: {
            type: String,
            default: '.jpeg,.jpg,.png,.gif,.bmp'
        },
        customClass: {
            type: String,
            default: ''
        },
        fileType: {
            default: 'image'
        },
        size: {
            default: 2
        },
        limit: {
            default: null
        },
        resolving: {
            // 分辨率
            default: () => [ 500, 500 ]
        },
        desc: {
            default: ''
        },
        required: {
            default: false
        },
        legend: {
            default: ''
        }
    },
    data() {
        return {
            loading: false, // 加载
            key: 1,
            dialogImageUrl: '',
            showImage: false, // 显示图片
            showCropper: false,
            fileUrl: undefined,
            cropperOptions: {
                // 裁剪组件的基础配置option
                img: '', // 裁剪图片的地址
                fixedNumber: this.resolving, // 截图框的宽高比例
                autoCropWidth: this.resolving[0],
                autoCropHeight: this.resolving[1]
            }
        }
    },
    computed: {
        fileList: {
            get() {
                if (this.fileData && this.key) {
                    return this.fileData.split(',').map((v) => {
                        return { url: v }
                    })
                } else {
                    return []
                }
            },
            set(val) {
                this.key += 1
                this.$emit('update:fileData', val.join(','))
            }
        }
    },
    beforeDestroy() {
        this.handleClosePreview()
    },
    methods: {
        // 上传前
        beforeUpload(file) {
            this.loading = true

            const isLtSize = file.size / 1024 / 1024 < this.size
            if (!isLtSize) {
                this.$message.error(
                    this.$t('文件大小不得超过', { size: this.size })
                )
            }

            const fileName = file.name
            const isLtType = this.accept.includes(
                fileName.slice(fileName.lastIndexOf('.'))
            )

            if (!isLtType) { this.$message.error(this.$t('上传文件格式与要求不符')) }

            this.loading = false

            return isLtSize && isLtType
        },
        // 上传错误
        uploadError() {
            this.$message({
                type: 'error',
                message: this.$t('文件上传失败')
            })
            this.loading = false
        },
        // 上传
        upload(req) {
            this.$nextTick(() => {
                const file = req.file

                this.cropperOptions.img = window.URL.createObjectURL(
                    new Blob([ file ])
                )
                this.fileUrl = file
                this.showCropper = true
            })
        },
        // 完成裁剪
        completeCropper(data) {
            console.log(data)
            const imgUrls = JSON.parse(JSON.stringify(this.fileData))

            this.$emit(
                'update:fileData',
                this.fileData && this.limit
                    ? imgUrls + ',' + data.url
                    : data.url
            )

            this.showCropper = false
            this.loading = false
        },
        // 关闭裁剪窗口
        closeCropper(file) {
            this.handleRemove(file)
            this.showCropper = false
            this.loading = false
        },
        // 删除文件
        handleRemove(file) {
            this.fileList = this.fileList
                .filter(item => item.url !== file.url)
                .map(v => v.url)
        },
        // 预览图片
        handlePreview(file) {
            this.dialogImageUrl = file.url
            document.body.classList.add('ofh')
            this.showImage = true
        },
        // 文件更改
        uploadChange(file, files) {
            // files.filter(item => item.uid !== file.uid)
        },
        // 上传成功
        uploadSuccess(res, file, fileList) {
            this.loading = false
        },
        // 超出文件限制
        uploadExceed(file, fileList) {
            this.$message.error(
                this.$t('超出文件上传数量限制', { limit: this.limit })
            )
        },
        // 过滤队列文件
        filterFile(file) {
            return this.fileList.find(item => item?.url === file?.url)
        },
        // 关闭图片预览
        handleClosePreview() {
            document.body.classList.remove('ofh')
            this.showImage = false
        }
    }
}
</script>
<style lang="stylus" scoped>
.upload-body {
    position: relative;

    .avatar {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 100;
    }

    .upload-icon-body {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 101;

        .avatar-uploader-icon {
            margin: 0;
            position: absolute;
            top: 56px;
        }
    }
}

.preview-image {
    object-fit: scale-down;
}

.tip-body {
    span {
        color: $color-main
    }
}

.preview-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9000;
    background: rgba(0, 0, 0, 0.4);

    .btn-close {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 9001;
        color: #fff;
        font-size: 34px;
        cursor: pointer;
    }

    img {
        max-width: 80%;
    }
}

::v-deep .el-upload-list__item {
  transition: none !important;
}

</style>
